import { apiGet } from "./api";

// converts to b64 with utf8. This prevents XML from breaking because it can't handle the ascii chars
export const utf8ToBase64 = (str: string): string => {
  const bytes = new TextEncoder().encode(str);
  let binary = "";
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  return btoa(binary);
}

// capitalizes each word in a status string, handling hyphenated statuses
export const capitalizeStatus = (status: string): string => {
  return status.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('-');
}

export const latLongToZipcode = async (lat: number, lng: number, org_id: number): Promise<string | null> => {
  try {
    const response = await apiGet(`/api/maps/lat-long-to-zipcode?lat=${lat}&lng=${lng}&org_id=${org_id}`);
    const data = await response.json();
    if (data.error) {
      throw new Error(data.error);
    }
    return data.zipcode as string;
  } catch (error) {
    console.error('Error converting lat/lng to zipcode:', error);
    return null;
  }
}
